import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

import "./assets/fonts/RastantyCortez.ttf";
import { MemorialContextProvider } from "./context/MemorialContext";
import { HelmetProvider } from "react-helmet-async";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <HelmetProvider>
        <MemorialContextProvider>
          <App />
        </MemorialContextProvider>
      </HelmetProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
